import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, Define, ValidationMessage, SettingState, TibboDataType,
} from '@appblocks/codegeneration/types';

export default class HTTP extends BaseFeature {
    constructor() {
        super();
        this.name = 'HTTP Header';
        this.id = 'http_header';
        this.fileLinks = [

        ];

        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'VALUE',
                name: 'Value',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        return errors;
    }
}
